import PropTypes from 'prop-types';

export const TodoTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  completed: PropTypes.bool,
};
